import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Aarthikreportnamuna6 = () => {
  const [selectedMonth, setSelectedMonth] = useState('जानेवारी');
  const [transactionType, setTransactionType] = useState('जमा');
  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log('Form submitted:', { selectedMonth, transactionType });
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleTransactionTypeChange = (e) => {
    setTransactionType(e.target.value);
  };

  const handleBack = () => {
    navigate('/aarthikreport');
  };

  const months = [
    'जानेवारी',
    'फेब्रुवारी',
    'मार्च',
    'एप्रिल',
    'मे',
    'जून',
    'जुलै',
    'ऑगस्ट',
    'सप्टेंबर',
    'ऑक्टोबर',
    'नोव्हेंबर',
    'डिसेंबर'
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          
          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-xl font-bold">नमुना 6</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">
              
              {/* Month Field */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  महिना:
                </label>
                <div className="relative flex-1">
                  <select
                    value={selectedMonth}
                    onChange={handleMonthChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  >
                    {months.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Transaction Type Radio Buttons */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  प्रकार:
                </label>
                <div className="flex items-center space-x-6">
                  {/* Credit Radio Button */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="credit"
                      name="transactionType"
                      value="जमा"
                      checked={transactionType === 'जमा'}
                      onChange={handleTransactionTypeChange}
                      className="w-4 h-4 text-[#267c77] focus:ring-[#267c77] border-gray-300"
                    />
                    <label htmlFor="credit" className="text-gray-700">
                      जमा
                    </label>
                  </div>

                  {/* Debit Radio Button */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="radio"
                      id="debit"
                      name="transactionType"
                      value="नावे"
                      checked={transactionType === 'नावे'}
                      onChange={handleTransactionTypeChange}
                      className="w-4 h-4 text-[#267c77] focus:ring-[#267c77] border-gray-300"
                    />
                    <label htmlFor="debit" className="text-gray-700">
                      नावे
                    </label>
                  </div>
                </div>
              </div>

            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-center">
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-8 py-3 rounded-md font-medium hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                नमुना 6
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Aarthikreportnamuna6;